import { render, staticRenderFns } from "./HeaderSmallScreenNgo.vue?vue&type=template&id=00ecb91c&scoped=true&"
import script from "./HeaderSmallScreenNgo.vue?vue&type=script&lang=js&"
export * from "./HeaderSmallScreenNgo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSmallScreenNgo.vue?vue&type=style&index=0&id=00ecb91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ecb91c",
  null
  
)

export default component.exports